// University of Alabama at Birmingham's bachelor's majors (#2839). Read on
// 2026-10-01 from UAB's official 2026-2027 Catalog of Undergraduate Programs
// (catalog.uab.edu/undergraduate): each school's and department's catalog
// page, checked against the catalog's Major Index. One entry per major and
// degree (65 in all); tracks and concentrations (the Art B.A.'s art
// history, studio and graphic and digital design concentrations, the
// Kinesiology and Communication Studies concentrations, and so on) are not
// listed separately. The five B.S. programs the catalog files under Joint
// Programs (College of Arts and Sciences with the School of Medicine) keep
// that group; Biomedical Engineering stays with the School of Engineering.
// Music Education is the catalog's School of Education page for the Music
// B.A.'s music education concentration. Natural Science's catalog page does
// not name its degree, so it carries none. "Industrial Distribution" is the
// school's own name for the major its department page heads "Distribution".
// Left out: minors, certificates, the UABTeach STEM Education minor, the
// individually designed major and graduate programs.
const majors = {
    "slug": "university-of-alabama-at-birmingham",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in UAB's official 2026-2027 Catalog of Undergraduate Programs, grouped by the school or college that offers it, with the degree it leads to. Concentrations, minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "Collat School of Business",
            "source": {
                "label": "UAB 2026-2027 Catalog of Undergraduate Programs, Collat School of Business",
                "url": "https://catalog.uab.edu/undergraduate/schoolofbusiness/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "B.S."
                },
                {
                    "name": "Economics",
                    "degree": "B.S."
                },
                {
                    "name": "Entrepreneurship",
                    "degree": "B.S."
                },
                {
                    "name": "Finance",
                    "degree": "B.S."
                },
                {
                    "name": "Human Resource Management",
                    "degree": "B.S."
                },
                {
                    "name": "Industrial Distribution",
                    "degree": "B.S."
                },
                {
                    "name": "Information Systems",
                    "degree": "B.S."
                },
                {
                    "name": "Management",
                    "degree": "B.S."
                },
                {
                    "name": "Marketing",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Arts and Sciences",
            "source": {
                "label": "UAB 2026-2027 Catalog of Undergraduate Programs, College of Arts and Sciences",
                "url": "https://catalog.uab.edu/undergraduate/collegeofartsciences/"
            },
            "majors": [
                {
                    "name": "African American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Art",
                    "degree": "B.A."
                },
                {
                    "name": "Art",
                    "degree": "B.F.A."
                },
                {
                    "name": "Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Communication Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Criminal Justice",
                    "degree": "B.S."
                },
                {
                    "name": "Digital Forensics",
                    "degree": "B.S."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "General Studies",
                    "degree": "Bachelor of General Studies"
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "Human Rights",
                    "degree": "B.A."
                },
                {
                    "name": "International Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Medical Sociology",
                    "degree": "B.S."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Musical Theatre",
                    "degree": "B.F.A."
                },
                {
                    "name": "Natural Science",
                    "degree": null
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.S."
                },
                {
                    "name": "Social Work",
                    "degree": "B.S.S.W."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Theatre",
                    "degree": "B.A."
                },
                {
                    "name": "World Languages and Literatures",
                    "degree": "B.A."
                },
                {
                    "name": "Writing and Media",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "Joint Programs",
            "source": {
                "label": "UAB 2026-2027 Catalog of Undergraduate Programs, Joint Programs",
                "url": "https://catalog.uab.edu/undergraduate/jointprograms/"
            },
            "note": "Joint between the College of Arts and Sciences and the Heersink School of Medicine.",
            "majors": [
                {
                    "name": "Bioinformatics",
                    "degree": "B.S."
                },
                {
                    "name": "Cancer Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Genetics and Genomic Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Immunology",
                    "degree": "B.S."
                },
                {
                    "name": "Neuroscience",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "School of Education and Human Sciences",
            "source": {
                "label": "UAB 2026-2027 Catalog of Undergraduate Programs, School of Education and Human Sciences",
                "url": "https://catalog.uab.edu/undergraduate/schoolofeducation/"
            },
            "majors": [
                {
                    "name": "Community Health and Human Services",
                    "degree": "B.S."
                },
                {
                    "name": "Early Childhood Education",
                    "degree": "B.S."
                },
                {
                    "name": "Elementary Education",
                    "degree": "B.S."
                },
                {
                    "name": "eSports Performance Management and Coaching",
                    "degree": "B.S."
                },
                {
                    "name": "Kinesiology",
                    "degree": "B.S."
                },
                {
                    "name": "Music Education",
                    "degree": "B.A.",
                    "note": "The music education concentration of the Music, B.A."
                },
                {
                    "name": "Secondary Education",
                    "degree": "B.S.",
                    "note": "Concentrations in English and General Social Science."
                }
            ]
        },
        {
            "name": "School of Engineering",
            "source": {
                "label": "UAB 2026-2027 Catalog of Undergraduate Programs, School of Engineering",
                "url": "https://catalog.uab.edu/undergraduate/schoolofengineering/"
            },
            "majors": [
                {
                    "name": "Biomedical Engineering",
                    "degree": "B.S.",
                    "note": "Joint with the School of Medicine."
                },
                {
                    "name": "Civil Engineering",
                    "degree": "B.S.C.E."
                },
                {
                    "name": "Electrical and Computer Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Engineering Design",
                    "degree": "Bachelor of Science in Engineering"
                },
                {
                    "name": "Materials Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "School of Health Professions",
            "source": {
                "label": "UAB 2026-2027 Catalog of Undergraduate Programs, School of Health Professions",
                "url": "https://catalog.uab.edu/undergraduate/schoolofhealthprofessions/"
            },
            "majors": [
                {
                    "name": "Biobehavioral Nutrition & Wellness",
                    "degree": "B.S."
                },
                {
                    "name": "Biomedical Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Disability Studies and Rehabilitation Science",
                    "degree": "B.S."
                },
                {
                    "name": "Health Care Management",
                    "degree": "B.S."
                },
                {
                    "name": "Medical Laboratory Science",
                    "degree": "B.S."
                },
                {
                    "name": "Nutrition Sciences",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "School of Nursing",
            "source": {
                "label": "UAB 2026-2027 Catalog of Undergraduate Programs, School of Nursing",
                "url": "https://catalog.uab.edu/undergraduate/schoolofnursing/"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "B.S.N."
                }
            ]
        },
        {
            "name": "School of Public Health",
            "source": {
                "label": "UAB 2026-2027 Catalog of Undergraduate Programs, School of Public Health",
                "url": "https://catalog.uab.edu/undergraduate/schoolofpublichealth/"
            },
            "majors": [
                {
                    "name": "Public Health",
                    "degree": "B.S."
                }
            ]
        }
    ]
};

export default majors;
